/* global imagepaths connect React Component */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Notifications from "./Navbar/Notifications";
import menus from "./navmenu";

const Header = (props) => {
    const handlesidebar = () => {
        document.body.classList.toggle("mini-sidebar");
    };
    const onMenuClik = () => {
        props.onMenuClick();
    };

    let pathname = props.location.pathname;

    const filterMenu = (menu)=>{
        let hasRoles = menu.roles||[];
        return hasRoles.length?hasRoles.includes(props.store?.user?.user_role):true;
    };

    return (
        <div className="header" style={{ right: "0px" }}>
            {/* Logo */}
            <div className="header-left">
                <Link to="/app/main/dashboard" className="logo">
                    <img src={imagepaths.headerlogo} alt="" />
                </Link>
            </div>
            {/* /Logo */}
            <a
                id="toggle_btn"
                onClick={handlesidebar}
            >
                <span className="bar-icon">
                    <span />
                    <span />
                    <span />
                </span>
            </a>
            {/* Header Title */}
            <div className="page-title-box">
                <h3></h3>
            </div>
            {/* /Header Title */}
            <a
                id="mobile_btn"
                className="mobile_btn"
                href="#"
                onClick={() => onMenuClik()}
            >
                <i className="fa fa-bars" />
            </a>
            {/* Header Menu */}
            <ul className="nav user-menu">
                {/* Search */}
                <li className="nav-item">
                    <div className="top-nav-search">
                        <a href="" className="responsive-search">
                            <i className="fa fa-search" />
                        </a>
                        <form>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search here"
                            />
                            <button className="btn" type="submit">
                                <i className="fa fa-search" />
                            </button>
                        </form>
                    </div>
                </li>
                <Notifications/>
                {/* /Message Notifications */}
                <li className="nav-item dropdown has-arrow main-drop">
                    <a
                        href="#"
                        className="dropdown-toggle nav-link"
                        data-bs-toggle="dropdown"
                    >
                        <span className="user-img me-1">
                            <img src={imagepaths.Avatar_21} alt="" />
                            <span className="status online" />
                        </span>
                        <span className="text-black">{props.store?.user?.user_name}</span>
                    </a>
                    <div className="dropdown-menu">
                        {
                            menus
                            .filter(filterMenu)
                            .map((menu,i)=>(
                                <Link key={'menu'+i} className="dropdown-item" to={menu.link}>
                                    <i className={menu.icon} /> <span>{menu.label}</span>
                                </Link> 
                            ))
                        }
                    </div>
                </li>
            </ul>
            {/* /Header Menu */}
            {/* Mobile Menu */}
            <div className="dropdown mobile-user-menu">
                <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <i className="fa fa-ellipsis-v" />
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                    <Link className="dropdown-item" to="/app/profile/employee-profile">
                        My Profile
                    </Link>
                    <Link className="dropdown-item" to="/settings/companysetting">
                        Settings
                    </Link>
                    <Link className="dropdown-item" to="/login">
                        Logout
                    </Link>
                </div>
            </div>
            {/* /Mobile Menu */}
        </div>
    );
};

export default connect(Header);
